import React from "react";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
import HoverTooltip from "@Components/Tooltip/HoverTooltip";

import IconButton from "@material-ui/core/IconButton";
import { InfoRounded } from "@material-ui/icons";

const Title = (props) => {
  const { t } = useTranslation();
  const { title, required, showInfoIcon, infoContent } = props;
  return (
    <Grid item xs={12}>
      <Typography variant="h6" style={{ textTransform: "capitalize" }}>
        {t(title)} {required ? <span style={{ color: "red" }}>*</span> : null}
        {showInfoIcon ? (
          <HoverTooltip title={infoContent}>
            <IconButton>
              <InfoRounded style={{ position: "absolute" }} color="primary" />
            </IconButton>
          </HoverTooltip>
        ) : null}
      </Typography>
      <Divider
        style={{ backgroundColor: "rgba(0, 0, 0, 0.6)", marginBottom: "10px" }}
      />
    </Grid>
  );
};

Title.propTypes = {
  title: PropTypes.string,
  required: PropTypes.bool,
  showInfoIcon: PropTypes.bool,
  infoContent: PropTypes.string,
};

export default Title;
